import React, {Component} from 'react';
import './LeftList.scss';
import {IntlProvider} from "react-intl";
import {NavLink} from "react-router-dom";
import ImagePlayer from "../../components/ImagePlayer/ImagePlayer";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
import {ReactComponent as BackArrowIcon} from '../../assets/Icons/play4.svg';
import {Helmet} from "react-helmet";
import languageManager from "../../providers/data-manager/language-manager";
import {Util} from "../../providers/Utils";
import {ReactComponent as LockIcon} from '../../assets/Icons/lock.svg';
import {ReactComponent as CloseIcon} from '../../assets/Icons/close-01.svg';

class LeftList extends Component {
    constructor(props) {
        super(props);
        this.musicPlayer = React.createRef();
        this.props.setMusicPlayer(this.musicPlayer);
        let locationData = this.props.locationData;

        this.state = {
            placeholder: false,
            writeCode: false,
            wrongCode: false,
            accessCode: "",
            message: "",
        }


        console.log("Locked? ", locationData.DisableMapLocationImage);
    }

    componentDidMount() {
        /* This calls a function that moves the Leaflet copyright box to the left when Leftlist is displayed */
        this.props.moveLeft(true);
        console.log("LeftList Did Mount");
        /* var _paq = window._paq = window._paq || [];
        _paq.push(['trackPageView']); */
        this.inBlur();
    }
    componentWillUnmount() {
        /* And this moves it back to the right when LeftList disappears */
        this.props.moveLeft(false);
    }

    inFocus = () =>  {
        this.setState({placeholder: false});
    };
    inBlur = () =>  {
        this.setState({placeholder: true});
    };
    openCodeWriter = (e) => {
        this.setState({ writeCode: true, accessCode: e.target.value},null);
        // input.focus();
    };

    evalCode = () => {
        console.log("EvalCode");
        const random = Math.random() > 0.8;
        if (!process.env.REACT_APP_webapp_apiurl) {
            return;
        }
        const url = process.env.REACT_APP_webapp_apiurl + '/accesscode/verify';
        const body = {
            accessCode: this.state.accessCode
        };
        const request = {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                'content-type': 'application/json',
                'application': 'Storkyrkan'
            }
        }

        // https://gwenapi.dev.onspotstory.com
        console.log("Request: ", url, request);
        return fetch(url, request).then(res => {
            console.log("Webapp API returned res: ", res);
            return res.json();
        })
        .then(response => {
            console.log("Response: ", response);
            if (typeof response === "object") {
                let newState = {};
                if (response.msg) {
                    newState.message = response.msg;
                }
                if (response.timeValid > 0) {
                    // newState.locked = false;
                    this.props.unlockItems(response);
                }
                this.setState(newState, null);
            }
        });
        /*if (random) {
            this.setState({ locked: false},null);
            // TODO This isn't actually how React wants ya to update values, it won't be saved
            // Also we should remove the lock on every location not just this one, if they are associated with the code..?
            this.props.locationData.DisableMapLocationImage = false;
        } else {
            this.setState({ wrongCode: true},null);
        }*/
    }

    render() {
        let locationData = this.props.locationData;
        //console.log("LeftListLocationData:",locationData);
        console.log("LocationData Video: >", locationData.Video, "<", !!locationData.Video, typeof locationData.Video, Util.isEmpty(locationData.Video));

        if (locationData.DisableMapLocationImage) {
            /*return(
                <div className={"LeftList"}>
                    <div className="lock"><LockIcon/>}/></div>
                    <div className="text">{translation[0].words.guidelock_description}</div>
                    <div className="access"><input type="text" ref='input' onFocus={this.inFocus.bind(this)} onBlur={this.inBlur.bind(this)} placeholder={translation[0].words.guidelock_accesscode} onChange={this.openCodeWriter.bind(this)} /></div>
                    {accessbtn}
                    <div className="result">{result}</div>
                    <div className="close" onClick={this.props.closeGuideObject}><div className="closeX">X</div></div>
                </div>
            );*/
            const result = "";
            let accessbtn = "";
            if (this.state.writeCode)
            {
                accessbtn = <button type="submit" className="AccessBtn" onClick={this.evalCode}>OK</button>;
            }
            return <div className={"LeftList Locked" + (this.state.wrongCode ? " Red": "")} >
                <div className="Lock"><LockIcon/></div>
                <div className="Text">{this.state.wrongCode ? languageManager.getLocalizedAppText("GuidelockDescriptionWrong") : languageManager.getLocalizedAppText("GuidelockDescription")}</div>
                <form method="post" onSubmit={(e) => { e.preventDefault(); this.evalCode()}}>
                    <div className="Access"><input type="text" ref='input' onFocus={this.inFocus} onBlur={this.inBlur} onChange={this.openCodeWriter} placeholder={this.state.placeholder ? languageManager.getLocalizedAppText("GuidelockAccesscode") : ""}/></div>
                    {accessbtn}
                </form>

                <div className="Result">{this.state.message}</div>
                <div className="Close"><NavLink to={"../"}><div className="CloseX"><CloseIcon/></div></NavLink></div>
            </div>;
        } else {
            return (
                <div className={"LeftList"}>
                    <Helmet>
                        <title>{languageManager.getLocalizedItem(locationData.Name)}</title>
                        {(locationData.Images && locationData.Images.length > 0 ? <meta property="og:image" content={Util.getMediaUrl(locationData.Images[0])}/> : "")}
                        <meta property="og:description" content={languageManager.getLocalizedItem(locationData.Text)}/>
                        <meta property="og:title" content={languageManager.getLocalizedItem(locationData.Name)}/>
                    </Helmet>

                    <div className="Headr">
                        <div className={"BackBtn"}><NavLink to={"../"}><BackArrowIcon className={"backarrow"}/>{languageManager.getLocalizedAppText("BackBtn")}</NavLink></div>
                        <div className={"Title"}>{languageManager.getLocalizedItem(locationData.Name)}</div>
                    </div>
                    {!Util.isEmpty(locationData.Video) ? <VideoPlayer video={languageManager.getLocalizedItem(locationData.Video)} videoPoster={languageManager.getLocalizedItem(locationData.VideoThumbnail)} walk={this.props.walk} location={locationData}/> : <></>}
                    <ImagePlayer
                        images={locationData.Images}
                        captions={languageManager.getLocalizedItem(locationData.ImageCaptions) || []}
                        openFullscreen={this.props.openFullscreen}
                    />
                    <div className={"Text"} dangerouslySetInnerHTML={{__html: languageManager.getLocalizedItem(locationData.Text)}}/>
                    {(languageManager.getLocalizedItem(locationData.Sound) ? <audio ref={this.musicPlayer} src={Util.getMediaUrl(languageManager.getLocalizedItem(locationData.Sound))}/> : <></>)}
                </div>
            );
        }
    }
}


export default LeftList;
